import { styled } from "@linaria/react";
import { Dialog } from "primereact/dialog";

const PDialog = styled(Dialog)<{ ref: React.ForwardedRef<Dialog> }>`
  &.p-dialog {
    box-shadow: 0px 0px 24px 0px rgba(17, 17, 17, 0.08);
  }
  &.no-header-dialog {
    .p-dialog-content {
      padding: 1rem;
    }
  }
`;

export const PDialogStyle = { PDialog };
